module.exports = __webpack_public_path__ + "static/media/be-food-logo.0f008dcf.png";